module.exports = new __parcel__URL__("metalabLogo.f836824f.jpg").toString();